// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.back-arrow[data-v-2fdef24c] {\r\n\tmargin-right: 10px;\n}\n.infobox[data-v-2fdef24c] {\r\n\tbackground: #fcef91;\r\n\tborder: 1px solid #cece3d;\r\n\tfont-size: 13px;\r\n\tpadding: 5px 10px;\r\n\tcolor: #615b2b;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
